/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Aria_CopyrightInputs */

const en_footer_aria_copyright = /** @type {(inputs: Footer_Aria_CopyrightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copyright notice`)
};

const es_footer_aria_copyright = /** @type {(inputs: Footer_Aria_CopyrightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aviso de derechos de autor`)
};

/**
* | output |
* | --- |
* | "Copyright notice" |
*
* @param {Footer_Aria_CopyrightInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const footer_aria_copyright = /** @type {((inputs?: Footer_Aria_CopyrightInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Aria_CopyrightInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_footer_aria_copyright(inputs)
	return en_footer_aria_copyright(inputs)
});